import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = { class: "text-body-5 desktop:gap-2 desktop:mt-12 mt-16 flex list-disc flex-col py-4 pl-20 text-gray-800" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["innerHTML"];
import { I18nInfo } from '@/user/models';
import { computed } from 'vue';
import clsx from 'clsx';
import { FilledButton, Modal, ModalFooter } from '@/user/components/common';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CertificateInfoModal',
    props: {
        modelValue: { type: Boolean },
        level: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const t_common = new I18nInfo('common');
        const t = new I18nInfo('certification.introduce.section1.certificateModal');
        const props = __props;
        const emit = __emit;
        const isOpen = computed({
            get: () => props.modelValue,
            set: (value) => emit('update:modelValue', value),
        });
        const certificationInfo = {
            essentials: {
                fullNameKey: 'essentials',
                feeAmount: '5',
                registrationNumber: '2024-004827',
            },
            associate: {
                fullNameKey: 'cloudArchitect',
                gradeName: 'Associate',
                feeAmount: '10',
                registrationNumber: '2025-003149',
            },
            professional: {
                fullNameKey: 'cloudArchitect',
                gradeName: 'Professional',
                feeAmount: '20',
                registrationNumber: '2025-003149',
            },
        };
        const certificateName = computed(() => {
            const key = certificationInfo[props.level]?.fullNameKey;
            return t.translate(`value.fullName.${key}`);
        });
        const certificateGrade = computed(() => {
            return certificationInfo[props.level]?.gradeName;
        });
        const certificateNumber = computed(() => {
            const number = certificationInfo[props.level]?.registrationNumber;
            const template = t.translate('value.registrationTemplate');
            return template.replace(/__NUMBER__/g, number);
        });
        const certificateFee = computed(() => {
            const amount = certificationInfo[props.level]?.feeAmount;
            const template = t.translate('value.feeTemplate');
            return template.replace(/__AMOUNT__/g, amount);
        });
        const noticeDesc = computed(() => {
            const template = t.translate('noticeDesc1');
            return template.replace(/__CERT_NAME__/g, certificateName.value);
        });
        const styles = {
            wrapper: 'space-y-40',
            group: 'flex flex-col gap-40',
            titleDesc: 'block text-title-2',
            note: 'text-body-5 text-gray-800',
            tableCover: 'w-full border-1 border-gray-250 rounded-12 overflow-hidden',
            table: 'w-full [&>tbody>tr:first-child>td]:border-t-0 [&>tbody>tr:first-child>th]:border-t-0',
            th: clsx('w-110 px-16 py-16 text-m-body-1 bg-gray-150 text-left border-gray-250 border-t-1', ' desktop:w-168 desktop:px-23 desktop:text-body-3'),
            td: clsx('px-15 py-17 border-gray-200 border-t-1 text-body-5', ' desktop:px-24 desktop:text-body-4'),
            inputTd: clsx('py-6 px-16 border-gray-200 border-t-1', ' desktop:py-8'),
            inputTd2: clsx('flex items-center gap-8', ' desktop:gap-10'),
            required: 'text-body-3 text-red-700',
            checkboxGroup: clsx('flex flex-col gap-8 py-20 border-t-1 border-gray-250', ' desktop:gap-0'),
            checkboxItem: 'flex items-center justify-between py-4',
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((isOpen).value = $event)),
                size: "large",
                title: "자격 정보"
            }, {
                content: _withCtx(() => [
                    _createElementVNode("div", {
                        class: _normalizeClass(styles.wrapper)
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(styles.group)
                        }, [
                            _createElementVNode("div", {
                                class: _normalizeClass(styles.tableCover)
                            }, [
                                _createElementVNode("table", {
                                    class: _normalizeClass(styles.table)
                                }, [
                                    _createElementVNode("tbody", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('attr.certificateName')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td)
                                            }, _toDisplayString(certificateName.value), 3)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('attr.level')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td)
                                            }, _toDisplayString(certificateGrade.value || _unref(t).translate('value.level')), 3)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('attr.type')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td)
                                            }, _toDisplayString(_unref(t).translate('value.type')), 3)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('attr.no')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td)
                                            }, _toDisplayString(certificateNumber.value), 3)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('attr.corp')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td)
                                            }, _toDisplayString(_unref(t).translate('value.corp')), 3)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('attr.fee')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td),
                                                innerHTML: certificateFee.value
                                            }, null, 10, _hoisted_1)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('attr.refund')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td),
                                                innerHTML: _unref(t).translate('value.refund')
                                            }, null, 10, _hoisted_2)
                                        ])
                                    ])
                                ], 2)
                            ], 2),
                            _createElementVNode("div", null, [
                                _createElementVNode("strong", {
                                    class: _normalizeClass(styles.titleDesc)
                                }, _toDisplayString(_unref(t).translate('noticeTitle')), 3),
                                _createElementVNode("ul", _hoisted_3, [
                                    _createElementVNode("li", {
                                        class: "desktop:py-1 py-3",
                                        innerHTML: noticeDesc.value
                                    }, null, 8, _hoisted_4),
                                    _createElementVNode("li", {
                                        class: "desktop:py-1 py-3",
                                        innerHTML: _unref(t).translate('noticeDesc2')
                                    }, null, 8, _hoisted_5)
                                ])
                            ]),
                            _createElementVNode("strong", {
                                class: _normalizeClass(styles.titleDesc)
                            }, _toDisplayString(_unref(t).translate('title.corp')), 3),
                            _createElementVNode("div", {
                                class: _normalizeClass(styles.tableCover)
                            }, [
                                _createElementVNode("table", {
                                    class: _normalizeClass(styles.table)
                                }, [
                                    _createElementVNode("tbody", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('attr.corpName')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td)
                                            }, _toDisplayString(_unref(t).translate('value.corpName')), 3)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('attr.ceo')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td)
                                            }, _toDisplayString(_unref(t).translate('value.ceo')), 3)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('attr.tel')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td)
                                            }, "1588-7967", 2)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('attr.mail')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td)
                                            }, "dl_cloudedu@nhn.com", 2)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('attr.address')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td)
                                            }, _toDisplayString(_unref(t).translate('value.address')), 3)
                                        ]),
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", {
                                                class: _normalizeClass(styles.th)
                                            }, _toDisplayString(_unref(t).translate('attr.homepage')), 3),
                                            _createElementVNode("td", {
                                                class: _normalizeClass(styles.td)
                                            }, "https://www.nhncloud.com", 2)
                                        ])
                                    ])
                                ], 2)
                            ], 2)
                        ], 2)
                    ], 2)
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(ModalFooter), null, {
                        default: _withCtx(() => [
                            _createVNode(_unref(FilledButton), {
                                class: "desktop:w-auto w-full",
                                color: "blue",
                                "desktop-size": "large",
                                "mobile-size": "medium",
                                onClick: _cache[0] || (_cache[0] = ($event) => (isOpen.value = false))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t_common).translate('button.confirm')), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
